import axios from "axios";
import { normalizePhone, isSriLankanPhone, isInternationalPhone } from "helpers/phoneHelper";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Local Storage Keys
const TOKEN_KEY = "token_patient";

// Token Management
export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  if (getToken) {
    localStorage.removeItem(TOKEN_KEY);
  }
};

// Parse JWT
export const parseJwt = (token) => {
  if (!token) return null;

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  } catch (e) {
    console.error("Error parsing token:", e);
    return null;
  }
};

// User Information
export const getUser = () => {
  const token = getToken();
  return parseJwt(token);
};

export const getUserLevel = () => {
  const user = getUser();
  return user?.userType || "GUEST";
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;

  const user = parseJwt(token);
  if (!user || !user.exp) return false;

  const currentTime = Math.floor(Date.now() / 1000);
  return user.exp > currentTime;
};

// Sign-In
export const signIn = async (email, password) => {
  try {
    const response = await axios.post(`${BASE_URL}user/patient/sign-in`, {
      email,
      password,
    });

    const token = response.data.data.token;
    setToken(token);

    return { success: true, user: getUser() };
  } catch (error) {
    console.error("Sign-in error:", error);
    return { success: false, message: "Invalid Credentials" };
  }
};

// Sign-In-OTP
export const signInWithOTP = async (phone, email, otp) => {
  try {

    const normalized = normalizePhone(phone);

    const endpoint = isSriLankanPhone(normalized)
      ? `${BASE_URL}user/patient/verify-otp-sign-in/srilanka`
      : `${BASE_URL}user/patient/verify-otp-sign-in/international`;

    const data = isSriLankanPhone(normalized)
      ? { phoneNumber: phone, email, otp }
      : { email, otp };

    const response = await axios.post(endpoint, data);

    const token = response.data.data.token;
    setToken(token);
    
    // return response?.data?.data;
    return { success: true, user: getUser(), response: response };
  } catch (error) {
    console.error("Guest sign-in error:", error);
    return { success: false, message: "Unable to sign in as guest" };
  }
};

// Guest Sign-In
export const guestSignIn = async () => {
  try {
    removeToken();
    const response = await axios.post(`${BASE_URL}user/patient/guest-sign-in`);
    const token = response.data.data.token;
    setToken(token);
    return { success: true, user: getUser() };
  } catch (error) {
    console.error("Guest sign-in error:", error);
    return { success: false, message: "Unable to sign in as guest" };
  }
};

export const getUserId = () => {
  let uId = null;
  const user = parseJwt(getToken());

  uId = user?.userId;

  return uId;
};

// Logout
export const logout = () => {
  removeToken();
};

export const getProfilePic = () => {
  const user = getUser();
  return user?.profileImagePath;
};

// Get User Email
export const getUserEmail = () => {
  const user = getUser();
  return user?.email || null; // Returns email if exists, otherwise null
};

// Get User Name
export const getUserName = () => {
  const user = getUser();
  return user?.username || null; // Returns username if exists, otherwise null
};
